module.exports = __webpack_public_path__ + "7bb1000165d1abfc75d537e83e63e8f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/national_inactive.svg
// module id = 61
// module chunks = 0